import { render, staticRenderFns } from "./SpaceCreate.vue?vue&type=template&id=640fbe74&scoped=true&"
import script from "./SpaceCreate.vue?vue&type=script&lang=js&"
export * from "./SpaceCreate.vue?vue&type=script&lang=js&"
import style0 from "./SpaceCreate.vue?vue&type=style&index=0&id=640fbe74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fbe74",
  null
  
)

export default component.exports